// SMS-via-email carrier templates. The "nnnn" placeholder in each template is
// replaced with the user-entered phone digits when building the address.

export const carrierGroups = [
  {
    country: 'AUSTRALIA',
    carriers: [
      { name: 'T-Mobile/Optus Zoo', template: '0nnnn@optusmobile.com.au' },
    ],
  },
  {
    country: 'AUSTRIA',
    carriers: [
      { name: 'T-Mobile', template: '43676nnnn@sms.t-mobile.at' },
    ],
  },
  {
    country: 'BULGARIA',
    carriers: [
      { name: 'Mtel', template: 'nnnn@sms.mtel.net' },
      { name: 'Globul', template: 'nnnn@sms.globul.bg' },
    ],
  },
  {
    country: 'CANADA',
    carriers: [
      { name: 'Aliant', template: 'nnnn@wirefree.informe.ca' },
      { name: 'Bell Mobility', template: 'nnnn@txt.bellmobility.ca' },
      { name: 'Fido', template: 'nnnn@fido.ca' },
      { name: 'MTS Mobility', template: 'nnnn@text.mtsmobility.com' },
      { name: 'Rogers Wireless', template: 'nnnn@pcs.rogers.com' },
      { name: 'Sasktel Mobility', template: 'nnnn@pcs.sasktelmobility.com' },
      { name: 'Telus', template: 'nnnn@msg.telus.com' },
      { name: 'Virgin Mobile', template: 'nnnn@vmobile.ca' },
    ],
  },
  {
    country: 'GERMANY',
    carriers: [
      { name: 'T-Mobile', template: '0nnnn@t-d1-sms.de' },
      { name: 'Vodafone', template: '0nnnn@vodafone-sms.de' },
      { name: 'O2', template: '0nnnn@o2online.de' },
      { name: 'E-Plus', template: '0nnnn@smsmail.eplus.de' },
    ],
  },
  {
    country: 'ICELAND',
    carriers: [
      { name: 'OgVodafone', template: 'nnnn@sms.is' },
      { name: 'Siminn', template: 'nnnn@box.is' },
    ],
  },
  {
    country: 'INDIA',
    carriers: [
      { name: 'Andhra Pradesh AirTel', template: '91nnnn@airtelap.com' },
      { name: 'Andhra Pradesh Idea Cellular', template: '9848nnnn@ideacellular.net' },
      { name: 'Chennai Skycell / Airtel', template: '919840nnnn@airtelchennai.com' },
      { name: 'Chennai RPG Cellular', template: '9841nnnn@rpgmail.net' },
      { name: 'Delhi Airtel', template: '919810nnnn@airtelmail.com' },
      { name: 'Delhi Hutch', template: '9811nnnn@delhi.hutch.co.in' },
      { name: 'Gujarat Idea Cellular', template: '9824nnnn@ideacellular.net' },
      { name: 'Gujarat Airtel', template: '919898nnnn@airtelmail.com' },
      { name: 'Gujarat Celforce / Fascel', template: '9825nnnn@celforce.com' },
      { name: 'Goa Airtel', template: '919890nnnn@airtelmail.com' },
      { name: 'Goa BPL Mobile', template: '9823nnnn@bplmobile.com' },
      { name: 'Goa Idea Cellular', template: '9822nnnn@ideacellular.net' },
      { name: 'Haryana Airtel', template: '919896nnnn@airtelmail.com' },
      { name: 'Haryana Escotel', template: '9812nnnn@escotelmobile.com' },
      { name: 'Himachal Pradesh Airtel', template: '919816nnnn@airtelmail.com' },
      { name: 'Karnataka Airtel', template: '919845nnnn@airtelkk.com' },
      { name: 'Kerala Airtel', template: '919895nnnn@airtelkerala.com' },
      { name: 'Kerala Escotel', template: '9847nnnn@escotelmobile.com' },
      { name: 'Kerala BPL Mobile', template: '9846nnnn@bplmobile.com' },
      { name: 'Kolkata Airtel', template: '919831nnnn@airtelkol.com' },
      { name: 'Madhya Pradesh Airtel', template: '919893nnnn@airtelmail.com' },
      { name: 'Maharashtra Airtel', template: '919890nnnn@airtelmail.com' },
      { name: 'Maharashtra BPL Mobile', template: '9823nnnn@bplmobile.com' },
      { name: 'Maharashtra Idea Cellular', template: '9822nnnn@ideacellular.net' },
      { name: 'Mumbai Airtel', template: '919892nnnn@airtelmail.com' },
      { name: 'Mumbai BPL Mobile', template: '9821nnnn@bplmobile.com' },
      { name: 'Punjab Airtel', template: '919815nnnn@airtelmail.com' },
      { name: 'Pondicherry BPL Mobile', template: '9843nnnn@bplmobile.com' },
      { name: 'Tamil Nadu Airtel', template: '919894nnnn@airtelmail.com' },
      { name: 'Tamil Nadu BPL Mobile', template: '919843nnnn@bplmobile.com' },
      { name: 'Tamil Nadu Aircel', template: '9842nnnn@airsms.com' },
      { name: 'Uttar Pradesh West Escotel', template: '9837nnnn@escotelmobile.com' },
    ],
  },
  {
    country: 'IRELAND',
    carriers: [
      { name: 'Meteor', template: 'nnnn@sms.mymeteor.ie' },
    ],
  },
  {
    country: 'ITALY',
    carriers: [
      { name: 'TIM', template: '0nnnn@timnet.com' },
      { name: 'Vodafone', template: '3**nnnn@sms.vodafone.it' },
    ],
  },
  {
    country: 'JAPAN',
    carriers: [
      { name: 'AU by KDDI', template: 'nnnn@ezweb.ne.jp' },
      { name: 'NTT DoCoMo', template: 'nnnn@docomo.ne.jp' },
      { name: 'Vodafone Chuugoku/Western', template: 'nnnn@n.vodafone.ne.jp' },
      { name: 'Vodafone Hokkaido', template: 'nnnn@d.vodafone.ne.jp' },
      { name: 'Vodafone Hokuriko/Central North', template: 'nnnn@r.vodafone.ne.jp' },
      { name: 'Vodafone Kansai/West, including Osaka', template: 'nnnn@k.vodafone.ne.jp' },
      { name: 'Vodafone Kanto/Koushin/East, including Tokyo', template: 'nnnn@t.vodafone.ne.jp' },
      { name: 'Vodafone Kyuushu/Okinawa', template: 'nnnn@q.vodafone.ne.jp' },
      { name: 'Vodafone Shikoku', template: 'nnnn@s.vodafone.ne.jp' },
      { name: 'Vodafone Touhoku/Niigata/North', template: 'nnnn@h.vodafone.ne.jp' },
      { name: 'Vodafone Toukai/Central', template: 'nnnn@c.vodafone.ne.jp' },
      { name: 'Willcom', template: 'nnnn@pdx.ne.jp' },
      { name: 'Willcom di', template: 'nnnn@di.pdx.ne.jp' },
      { name: 'Willcom dj', template: 'nnnn@dj.pdx.ne.jp' },
      { name: 'Willcom dk', template: 'nnnn@dk.pdx.ne.jp' },
    ],
  },
  {
    country: 'NETHERLANDS',
    carriers: [
      { name: 'T-Mobile', template: '31nnnn@gin.nl' },
      { name: 'Orange', template: '0nnnn@sms.orange.nl' },
    ],
  },
  {
    country: 'SINGAPORE',
    carriers: [
      { name: 'M1', template: 'nnnn@m1.com.sg' },
    ],
  },
  {
    country: 'SOUTH AFRICA',
    carriers: [
      { name: 'Vodacom', template: 'nnnn@voda.co.za' },
    ],
  },
  {
    country: 'SPAIN',
    carriers: [
      { name: 'Telefonica Movistar', template: '0nnnn@movistar.net' },
      { name: 'Vodafone', template: '0nnnn@vodafone.es' },
    ],
  },
  {
    country: 'SWEDEN',
    carriers: [
      { name: 'Tele2', template: '0nnnn@sms.tele2.se' },
    ],
  },
  {
    country: 'UNITED KINGDOM',
    carriers: [
      { name: 'O2 #1', template: '44nnnn@mobile.celloneusa.com' },
      { name: 'O2 #2', template: '44nnnn@mmail.co.uk' },
      { name: 'Orange', template: '0nnnn@orange.net' },
      { name: 'T-Mobile', template: '0nnnn@t-mobile.uk.net' },
      { name: 'Virgin Mobile', template: '0nnnn@vxtras.com' },
      { name: 'Vodafone', template: '0nnnn@vodafone.net' },
    ],
  },
  {
    country: 'UNITED STATES',
    carriers: [
      { name: 'Teleflip', template: 'nnnn@teleflip.com' },
      { name: 'Alltel', template: 'nnnn@message.alltel.com' },
      { name: 'Ameritech', template: 'nnnn@paging.acswireless.com' },
      { name: 'ATT Wireless', template: 'nnnn@txt.att.net' },
      { name: 'Bellsouth', template: 'nnnn@bellsouth.cl' },
      { name: 'Boost', template: 'nnnn@myboostmobile.com' },
      { name: 'CellularOne', template: 'nnnn@mobile.celloneusa.com' },
      { name: 'CellularOne MMS', template: 'nnnn@mms.uscc.net' },
      { name: 'Cingular', template: '1nnnn@mobile.mycingular.com' },
      { name: 'Edge Wireless', template: 'nnnn@sms.edgewireless.com' },
      { name: 'Sprint PCS', template: 'nnnn@messaging.sprintpcs.com' },
      { name: 'T-Mobile', template: 'nnnn@tmomail.net' },
      { name: 'Metro PCS', template: 'nnnn@mymetropcs.com' },
      { name: 'Nextel', template: 'nnnn@messaging.nextel.com' },
      { name: 'O2', template: 'nnnn@mobile.celloneusa.com' },
      { name: 'Orange', template: 'nnnn@mobile.celloneusa.com' },
      { name: 'Qwest', template: 'nnnn@qwestmp.com' },
      { name: 'Rogers Wireless', template: 'nnnn@pcs.rogers.com' },
      { name: 'Telus Mobility', template: 'nnnn@msg.telus.com' },
      { name: 'US Cellular', template: 'nnnn@email.uscc.net' },
      { name: 'Verizon', template: 'nnnn@vtext.com' },
      { name: 'Virgin Mobile', template: 'nnnn@vmobl.com' },
      { name: 'Cricket', template: 'nnnn@sms.cricketwireless.net' },
      { name: 'Google Fi', template: 'nnnn@msg.fi.google.com' },
      { name: 'Xfinity Mobile', template: 'nnnn@vtext.com' },
    ],
  },
];

const allCarriers = carrierGroups.flatMap(g => g.carriers);

// Split a template like "0nnnn@t-d1-sms.de" into { prefix: "0", domain: "t-d1-sms.de" }
function templateParts(template) {
  const [local = '', domain = ''] = String(template).split('@');
  const prefix = local.replace(/nnnn$/, '');
  return { prefix, domain };
}

// Build a full address from a carrier template and the user-entered digits.
export function buildCarrierAddress(template, digits) {
  if (!template) return digits;
  const { prefix, domain } = templateParts(template);
  return `${prefix}${digits}@${domain}`;
}

// Parse an existing address back into a carrier template + the user's digits.
// Falls back gracefully when no carrier matches.
export function parseCarrierAddress(address) {
  if (!address) return { digits: '', template: '' };
  const [local = '', domain = ''] = String(address).split('@');
  if (!domain) return { digits: local, template: '' };
  const carrier = allCarriers.find(c => templateParts(c.template).domain === domain);
  if (!carrier) return { digits: local, template: '' };
  const { prefix } = templateParts(carrier.template);
  const digits = prefix && local.startsWith(prefix) ? local.slice(prefix.length) : local;
  return { digits, template: carrier.template };
}
